<template>
  <div class="home page-width-warpper">
    <div class="flex-warpper">
      <div class="flex-item" style="flex: 2">
        <Wapper
          title="协会动态"
          :border="false"
          :padding="0"
          @more="$router.push('/dynamic')"
        >
          <div style="margin-top: 11px; display: flex" v-if="!!dynamic.length">
            <div class="flex-item">
              <el-carousel
                height="252px"
                indicator-position="none"
                :interval="3000"
              >
                <el-carousel-item v-for="(item, i) in dynamicImages" :key="i">
                  <img
                    class="swiper-img"
                    :src="item.icon"
                    @click="toDetail(item)"
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="flex-item">
              <div class="first-news" @click="toDetail(dynamic[0])">
                {{ hiddenText(dynamic[0].title)
                }}<span>{{ dynamic[0].createTime }}</span>
              </div>
              <ul class="news">
                <li
                  v-for="(item, i) in dynamicList"
                  :key="i"
                  style="line-height: 22px"
                  @click="toDetail(item)"
                >
                  <p>{{ item.title }}</p>
                  <span>{{ item.createTime }}</span>
                </li>
              </ul>
            </div>
          </div>
        </Wapper>
      </div>
      <div class="flex-item">
        <Wapper title="通知公告" @more="$router.push('/notice')">
          <ul class="news">
            <li v-for="(item, i) in notice" :key="i" @click="toDetail(item)">
              <p>{{ item.title }}</p>
              <span>{{ item.createTime }}</span>
            </li>
          </ul>
        </Wapper>
      </div>
    </div>
    <div class="flex-warpper">
      <div class="flex-item" v-for="(news, index) in newsList" :key="index">
        <Wapper :title="news.name" @more="$router.push('/' + news.path)">
          <ul class="news">
            <li v-for="(item, i) in news.list" :key="i" @click="toDetail(item)">
              <p>{{ item.title }}</p>
            </li>
          </ul>
        </Wapper>
      </div>
    </div>
    <div style="margin: 12px auto">
      <Wapper title="产品展示" @more="$router.push('/product')">
        <ul class="prduct">
          <li
            v-for="(item, i) in product"
            :key="i"
            @click="$router.push('/productDetail?id=' + item.id)"
          >
            <div style="overflow: hidden; border-radius: 4px">
              <img :src="item.icon" />
            </div>
            <p>{{ item.title }}</p>
          </li>
        </ul>
      </Wapper>
    </div>
    <div class="flex-warpper">
      <div class="flex-item" v-for="(news, index) in newsList2" :key="index">
        <Wapper :title="news.name" @more="$router.push('/' + news.path)">
          <ul class="news">
            <li
              v-for="(item, i) in news.list"
              :key="i"
              @click="news.path === 'down' ? toLink(item.icon) : toDetail(item)"
            >
              <p>{{ item.title }}</p>
              <!-- 添加对 会刊彩页iconTwo字段的判断 -->
              <!-- <span
                v-if="item.iconTwo"
                class="icon-two"
                @click.stop="toLinkWithIconTwo(item.iconTwo)"
                >会刊彩页</span
              > -->
            </li>
          </ul>
        </Wapper>
      </div>
    </div>
    <div style="margin: 12px auto">
      <Wapper title="友情链接" :more="false">
        <ul class="links">
          <li v-for="(item, i) in links" :key="i" @click="toLink(item.summary)">
            {{ item.title }}
          </li>
        </ul>
      </Wapper>
    </div>
    <MoveWindow v-if="!!moveImg">
      <img :src="moveImg" style="display: block; width: 100%" />
    </MoveWindow>
  </div>
</template>

<script>
// @ is an alias to /src
import Wapper from "./components/Wapper.vue";
import Swiper from "./components/Swiper.vue";
import MoveWindow from "./components/MoveWindow.vue";
import { pageByCode } from "@/api/index";

export default {
  name: "Home",
  components: {
    Wapper,
    Swiper,
    MoveWindow,
  },
  data() {
    return {
      links: [],
      newsCurrent: 0,
      newsList: [
        {
          name: "政策法规",
          path: "rule",
          code: "laws_regulations",
          list: [],
        },
        {
          name: "行业资料",
          path: "data",
          code: "industry_information",
          list: [],
        },
        {
          name: "党建廉政",
          path: "party",
          code: "gang",
          list: [],
        },
      ],
      newsList2: [
        {
          name: "专委会资讯",
          path: "news",
          code: "conference_news",
          list: [],
        },
        {
          name: "专委会工作条例",
          path: "work",
          code: "committee_work",
          list: [],
        },
        {
          name: "会刊下载",
          path: "down",
          code: "proceedings_download",
          list: [],
        },
      ],
      dynamicImages: [],
      dynamic: [],
      notice: [],
      product: [],
      moveImg: "",
    };
  },
  created() {
    this.getData("news", "dynamicImages", -1, 5);
    this.getData("association_dynamic", "dynamic");
    this.getData("notice", "notice");
    this.newsList.forEach((item, i) => {
      this.getData(item.code, "newsList", i);
    });
    this.getData("product_display", "product");
    this.newsList2.forEach((item, i) => {
      this.getData(item.code, "newsList2", i);
    });
    this.getData("friendly_link", "links", -1, 50);
    pageByCode({ pageNum: 1, pageSize: 1, code: "year_float" }).then((res) => {
      const resList = res.data?.records || [];
      if (!resList.length) return;
      this.moveImg = resList[0].icon;
    });
  },
  computed: {
    dynamicList() {
      return this.dynamic.filter((f, i) => i > 0 && i < 9);
    },
  },
  methods: {
    swiperChange(i) {
      this.newsCurrent = i;
    },
    hiddenText(text) {
      let text1 = text || "";
      if (text1.length > 33) {
        text1 = text1.substring(0, 30) + "…";
      }
      return text1;
    },
    toLink(link) {
      window.open(link, "_blank");
    },
    getData(code, list, i = -1, pageSize = 10) {
      pageByCode({ pageNum: 1, pageSize, code }).then((res) => {
        const resList = res.data?.records || [];
        const resList2 = resList.map((item) => {
          item.createTime = item.createTime.split(" ")[0];
          return item;
        });
        i < 0 ? (this[list] = resList2) : (this[list][i].list = resList2);
      });
    },
    toDetail(item, title) {
      this.$router.push(
        `/newsDetail?id=${item.id}&code=${item.code}&title=${
          title || ""
        }&home=1`,
      );
    },
    // 添加新的方法
    toLinkWithIconTwo(link) {
      window.open(link, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.home {
  .flex-warpper {
    display: flex;
    margin: 12px auto;
    .flex-item {
      flex: 1;
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
    .news {
      margin-top: 6px;
      li {
        display: flex;
        justify-content: space-between;
        line-height: 24px;
        font-size: 12px;
        position: relative;
        padding-left: 10px;
        &::before {
          content: "";
          position: absolute;
          left: 2px;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background: #555;
        }
        p {
          flex: 1;
          color: #555;
          cursor: pointer;
          @include clamp(1);
          &:hover {
            color: $main-color;
            text-decoration: underline;
          }
        }
        span {
          color: #888;
          margin-left: 10px;
        }
        // 添加新的样式
        .icon-two {
          color: #4ce713;
          margin-left: 10px;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .swiper-img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .first-news {
      background: rgba($color: $main-color, $alpha: 0.4);
      color: $main-color;
      height: 70px;
      border-radius: 4px;
      padding: 15px;
      box-sizing: border-box;
      line-height: 1.5;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
      span {
        margin-left: 10px;
      }
    }
  }
  .prduct {
    display: flex;
    flex-wrap: wrap;
    li {
      margin: 6px;
      width: 148px;
      cursor: pointer;

      &:hover {
        img {
          transform: scale(1.3);
        }
        p {
          color: $main-color;
          text-decoration: underline;
        }
      }
      img {
        display: block;
        width: 100%;
        height: 112px;
        object-fit: cover;
        transition: all 0.5s;
      }
      p {
        margin-top: 5px;
        text-align: center;
        font-size: 12px;
        color: #555;
        @include clamp(1);
      }
    }
  }
  .links {
    display: flex;
    flex-wrap: wrap;
    li {
      margin: 3px 6px;
      width: 178px;
      font-size: 12px;
      color: #555;
      @include clamp(1);
      cursor: pointer;
      &:hover {
        color: $main-color;
        text-decoration: underline;
      }
    }
  }
}
</style>
